import type BaseSettingHandler from '@/app/editor/sidebar/settings/setting-handler/BaseSettingHandler';

export type Setting = {
  // id: string;
  default_value?: string;
  caption?: string;
  options?: any;
  items?: any;
  links?: any;
  visible?: any;
  readonly?: string;
};
// export type Content= {content:""}
export type Data = {
  items: Array<any>;
};

export type Lib = {
  id: string;
};

export type Font = {
  id: string;
};
export interface TypeSettings {
  snippet: any;
  atom: AtomModel;
  notInitChildren: boolean;
}

export interface SnippetModel {
  id: string;
  name: string;
  slug: string;
  groupName: string;
  settings: Array<Setting>;
  data: Data;
  html: string;
  style: string;
  libs: Array<Lib>;
  fonts: Array<Font>;
  version: number;
}
export interface TypeExportData {
  html: string;
  bkHtml: string;
  style: string;
  script: string;
  libs: Array<Lib>;
  fonts: Array<string>;
}
export type TabSettingsData = {
  $atom: JQuery;
  atom: AtomModel;
  tab: string;
  drag: boolean;
  capture: boolean;
  forceOpen?: boolean;
};
export interface AtomModel {
  type: string; // module, element, row
  id: string;
  nodeId: string;
  name: string;
  slug: string;
  groupName: string; // product, product list
  settings: Array<any>;
  data: Data;
  class: string;
  html: string;
  style: string;
  script: string;
  libs: Array<Lib>;
  fonts: Array<Font>;
  version: number;
  isAutorenderSetting?: boolean;
  formControlSettings?: Array<FormControlSetting>;
  settingHandler?: BaseSettingHandler[];
}

export type ResponsiveProp = {
  name: string;
  property: string;
};

export type FormControlSetting = {
  type: string;
  name: string; // key of object, key of setting form field eg: {"name": "text-color", "id": "text-color", ...}
  caption?: string;
  targetSelectors?: Array<string>; // target to query eg: "h1,h2,h3"..
  targetSelector?: string; // target to query eg: ".class-name"
  refreshType?: 'all' | 'css' | undefined; // can be "css" or "all"
  property: string; // property of css eg: color, font-weight, line-height ...
  default_value?: any;
  unit?: any; // eg: px, em, % ...
  relatedField?: string; // value dependencies with other data fields eg: { box-shadow-enable : 1} => {box-shadow-color : red} || {"name": "box-shadow-color", "relatedField" : "box-shadow-enable"}
  links?: any; // value = stack=> property css stacking context eg: transform/filter/perspective/text-shadow/border/margin/padding ...
  fieldType?: string; // field control type, eg: color, box-shadow, margin...
  replaceData?: {
    replaceTarget: string;
    replaceType: string;
  }; // combined with targetSelector to replace a html string eg: [<i class="gf_icon fa fa-apple"></i>] => [<i class="gf_icon fa fa-arrows-alt"></i>]
  condition?: {
    syntax?: string;
    success: any;
    fail: any;
    hasClass?: string; // support custom:jquery
  };
  attrStoredSelector?: string; // stored attr in to html to responsive eg: data-stretch-xs=1
  require?: boolean;
  options?: {
    key: string;
    value: string;
  }[];
  items?: any;
  visible?: string;
  show?: boolean;
  class?: string;
  responsive?: boolean;
  screen?: {
    xs: ResponsiveProp;
    sm: ResponsiveProp;
    md: ResponsiveProp;
    lg: ResponsiveProp;
  };
  // value = 1,-1. array = value.split(",") // 1 là sử dụng $self thay cho atom, -1 là sử dụng $atom mặc định
  // array trên quy định:
  // array[0] -> Là setting quy định cho readStyle (Trong atom sẽ là function: readDataFormControls)
  // array[1] -> Là setting quy định cho writeStyle (Trong atom sẽ là function: saveFormControls)
  selfSelector?: string;
  activePanelSelector?: string;
  shadow?: {
    color?: any;
    angle?: any;
    distance?: any;
    blur?: any;
    spread?: any;
    type?: any;
    style?: any;
  };
  isBoxShadowGroup?: boolean;
  isSelf?: boolean;
  dataValue?: any;
  list_unit?: string;
  mode?: string;
  requires?: string;
  columns?: string;
};

export interface Settings {
  inputName: string;
  defaultValue: string;
  property: string;
}

export enum AtomGroup {
  Product = 'product',
  ProductList = 'product-list',
  ChildProduct = 'child-product',
  Article = 'article',
  ArticleList = 'article-list',
  ChildArticle = 'child-article',
  Module = 'module',
  Element = 'element',
  Row = 'row',
  ChildCollectionPage = 'child-page-collection',
  ChildReview = 'child-review',
  ChildProductPage = 'child-product-page',
  ChildProductAndProductPage = 'child-product-and-product-page',
  ChildCollection = 'child-collection',
  ThirdParties = '3rd-parties',
}
